import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "p-2 surface-border border-bottom-2 formgrid grid m-0" }
const _hoisted_2 = { class: "col-4 text-left flex align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", {
  class: "pi pi-copy",
  style: {"font-size":"1.2rem"}
}, null, -1)
const _hoisted_4 = { class: "col-4 text-center justify-content-center align-items-center" }
const _hoisted_5 = {
  key: 0,
  class: "p-2 col-4 justify-content-end text-right"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)
const _hoisted_7 = { class: "p-2 surface-border border-bottom-2 flex flex-nowrap align-items-center" }
const _hoisted_8 = { class: "flex-1 flex-column md:flex-row flex pb-2 pt-2 font-medium text-xl" }
const _hoisted_9 = { class: "flex w-5 uppercase" }
const _hoisted_10 = { class: "flex w-4 ml-1" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-user pr-2" }, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "flex w-4 ml-1"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-home pr-2" }, null, -1)
const _hoisted_14 = { class: "flex-1 md:flex-2 flex flex-row align-items-center justify-content-center gap-2" }
const _hoisted_15 = {
  key: 0,
  class: "w-full flex flex-row align-items-center justify-content-center gap-2"
}
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", {
  for: "state",
  class: ""
}, "Zmeniť stav", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-clock" }, null, -1)
const _hoisted_18 = { class: "flex flex-column align-items-center justify-content-center pt-2 pb-2" }
const _hoisted_19 = { class: "formgrid grid" }
const _hoisted_20 = { class: "field col-12 md:col-12 lg:col-6" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", { for: "last-name" }, "Meno", -1)
const _hoisted_22 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { for: "email" }, "Email", -1)
const _hoisted_24 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { for: "phone" }, "Mobil", -1)
const _hoisted_26 = { class: "formgrid grid" }
const _hoisted_27 = { class: "field col-12 md:col-6 lg:col-6" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", { for: "company" }, "Spoločnosť", -1)
const _hoisted_29 = { class: "field col-12 md:col-3 lg:col-3" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "ico" }, "IČO", -1)
const _hoisted_31 = { class: "field col-12 md:col-3 lg:col-3" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", { for: "vat" }, "DIČ", -1)
const _hoisted_33 = { class: "formgrid grid" }
const _hoisted_34 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("label", { for: "addressFirst" }, "Ulica a číslo", -1)
const _hoisted_36 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("label", { for: "addressSecond" }, "Doplnok k adrese", -1)
const _hoisted_38 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { for: "city" }, "Mesto/Obec", -1)
const _hoisted_40 = { class: "field col-12 md:col-6 lg:col-3" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "zip" }, "PSČ", -1)
const _hoisted_42 = { class: "formgrid grid" }
const _hoisted_43 = { class: "field col-12" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("label", { for: "comment" }, "Komentár", -1)
const _hoisted_45 = { class: "mt-2 flex flex-wrap justify-content-center gap-3" }
const _hoisted_46 = {
  key: 1,
  class: "flex flex-row flex-wrap my-2 ml-4 gap-3 w-full"
}
const _hoisted_47 = { class: "sm:w-12 md:w-5 lg:w-5 xl:w-5" }
const _hoisted_48 = { class: "sm:w-12 md:w-6 lg:w-6 xl:w-6" }
const _hoisted_49 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl" }, " Rezervácia kusov ", -1)
const _hoisted_50 = {
  key: 3,
  class: "flex flex-row flex-wrap my-2 ml-4 justify-content-start w-full"
}
const _hoisted_51 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl" }, " Komunikácia so zákazníkmi a dodávateľmi ", -1)
const _hoisted_52 = { class: "mb-3" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "font-medium text-xl" }, " Komunikácia v rámci firmy ", -1)
const _hoisted_54 = { class: "mb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PrimevueButton = _resolveComponent("PrimevueButton")!
  const _component_PrimevueTag = _resolveComponent("PrimevueTag")!
  const _component_PrimevueSelect = _resolveComponent("PrimevueSelect")!
  const _component_FloatLabel = _resolveComponent("FloatLabel")!
  const _component_Fieldset = _resolveComponent("Fieldset")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimevuePanel = _resolveComponent("PrimevuePanel")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PrimevueCard = _resolveComponent("PrimevueCard")!
  const _component_CortizoProform = _resolveComponent("CortizoProform")!
  const _component_AttachmentsByType = _resolveComponent("AttachmentsByType")!
  const _component_ReservedItems = _resolveComponent("ReservedItems")!
  const _component_EditorMessage = _resolveComponent("EditorMessage")!
  const _component_CommunicationList = _resolveComponent("CommunicationList")!
  const _component_EditorMessageInt = _resolveComponent("EditorMessageInt")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, [
          _createTextVNode("Kód pre komunikáciu: "),
          _createElementVNode("strong", null, "[Pifema #" + _toDisplayString($data.store.order.orderCode) + "]", 1)
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_PrimevueButton, {
          onClick: $options.copyOrderCodeToClipboard,
          text: "",
          rounded: "",
          class: "ml-2",
          style: {"padding":"0.125rem","min-width":"auto","width":"auto"}
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["onClick"])), [
          [
            _directive_tooltip,
            'Skopírovať kód',
            void 0,
            { top: true }
          ]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createTextVNode("Aktuálny stav: "),
        _createVNode(_component_PrimevueTag, {
          class: "p-2 ml-1 font-medium text-base justify-content-center",
          value: $data.store.order.currentState.name,
          style: _normalizeStyle({ backgroundColor: $data.store.order.currentState.color })
        }, null, 8, ["value", "style"])
      ]),
      ($data.store.order.id > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("em", null, [
              _createTextVNode("Objednávka naposledy uložená "),
              _hoisted_6,
              _createTextVNode(" " + _toDisplayString($options.Utils.parseToSlovakDateTime($data.store.order.modifiedAt)) + " - " + _toDisplayString($data.store.order.modifiedUser.firstName) + " " + _toDisplayString($data.store.order.modifiedUser.lastName), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, "Objednávka #" + _toDisplayString($data.store.order.orderCode), 1),
        _createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createTextVNode(" " + _toDisplayString($data.store.order.customer.lastName) + " ", 1),
          _withDirectives(_createVNode(_component_PrimevueButton, {
            type: "button",
            icon: "pi pi-pencil",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (this.editedOrder = !this.editedOrder)),
            text: "",
            raised: "",
            size: "small",
            class: "ml-2"
          }, null, 512), [
            [
              _directive_tooltip,
              { value: 'Editácia zákazníka' },
              void 0,
              { top: true }
            ]
          ])
        ]),
        ($data.store.order.customer.city)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _hoisted_13,
              _createTextVNode(" " + _toDisplayString($data.store.order.customer.city), 1)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_14, [
        ($data.store.order.id > 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
              _createVNode(_component_FloatLabel, { class: "flex-1" }, {
                default: _withCtx(() => [
                  _createVNode(_component_PrimevueSelect, {
                    inputId: "state",
                    modelValue: this.selectState,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((this.selectState) = $event)),
                    options: $data.store.orderStates,
                    optionLabel: "name",
                    optionValue: "id",
                    class: "w-full",
                    onChange: _cache[2] || (_cache[2] = ($event: any) => ($options.confirmState()))
                  }, null, 8, ["modelValue", "options"]),
                  _hoisted_16
                ]),
                _: 1
              }),
              (this.$route.params.orderId > 0)
                ? (_openBlock(), _createBlock(_component_Fieldset, {
                    key: 0,
                    legend: "Prehľad stavov",
                    class: "flex-1",
                    toggleable: "",
                    collapsed: true
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("ul", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.store.orderHistory, (history) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: history.id
                          }, [
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString($options.Utils.formatToSlovak(history.changeDate)) + " ", 1),
                            _createVNode(_component_PrimevueTag, {
                              value: history.state.name,
                              style: _normalizeStyle({ backgroundColor: history.state.color })
                            }, null, 8, ["value", "style"]),
                            _createTextVNode(" - " + _toDisplayString(history.user.firstName) + " " + _toDisplayString(history.user.lastName), 1)
                          ]))
                        }), 128))
                      ])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      (this.editedOrder)
        ? (_openBlock(), _createBlock(_component_PrimevueCard, {
            key: 0,
            class: "sm:w-10 md:w-10 lg:w-10 xl:w-10 m-2"
          }, {
            content: _withCtx(() => [
              _createElementVNode("form", {
                onSubmit: _cache[14] || (_cache[14] = _withModifiers(
//@ts-ignore
(...args) => ($options.submitHandler && $options.submitHandler(...args)), ["prevent"])),
                name: "userForm"
              }, [
                _createVNode(_component_PrimevuePanel, {
                  header: "Zákazník",
                  class: "border-solid border-1 surface-border"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _hoisted_21,
                        _createVNode(_component_InputText, {
                          class: _normalizeClass(["w-full", `${$setup.v$.store.order.customer.lastName.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.store.order.customer.lastName.$error,
                          modelValue: $data.store.order.customer.lastName,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($data.store.order.customer.lastName) = $event)),
                          type: "text",
                          name: "last-name",
                          id: "last-name"
                        }, null, 8, ["class", "invalid", "modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.store.order.customer.lastName.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_22, [
                        _hoisted_23,
                        _createVNode(_component_InputText, {
                          class: _normalizeClass(["w-full", `${$setup.v$.store.order.customer.email.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.store.order.customer.email.$error,
                          modelValue: $data.store.order.customer.email,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($data.store.order.customer.email) = $event)),
                          type: "email",
                          name: "email",
                          id: "email"
                        }, null, 8, ["class", "invalid", "modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.store.order.customer.email.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _hoisted_25,
                        _createVNode(_component_InputText, {
                          class: _normalizeClass(["w-full", `${$setup.v$.store.order.customer.phone.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.store.order.customer.phone.$error,
                          modelValue: $data.store.order.customer.phone,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($data.store.order.customer.phone) = $event)),
                          type: "text",
                          name: "phone",
                          id: "phone"
                        }, null, 8, ["class", "invalid", "modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.store.order.customer.phone.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _hoisted_28,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.company,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($data.store.order.customer.company) = $event)),
                          type: "text",
                          name: "company",
                          id: "company"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_29, [
                        _hoisted_30,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.ico,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($data.store.order.customer.ico) = $event)),
                          type: "text",
                          name: "ico",
                          id: "ico"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_31, [
                        _hoisted_32,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.vat,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($data.store.order.customer.vat) = $event)),
                          type: "text",
                          name: "vat",
                          id: "vat"
                        }, null, 8, ["modelValue"])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _hoisted_35,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.addressLine1,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($data.store.order.customer.addressLine1) = $event)),
                          type: "text",
                          name: "addressFirst",
                          id: "addressFirst"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        _hoisted_37,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.addressLine2,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($data.store.order.customer.addressLine2) = $event)),
                          type: "text",
                          name: "addressSecond",
                          id: "addressSecond"
                        }, null, 8, ["modelValue"])
                      ]),
                      _createElementVNode("div", _hoisted_38, [
                        _hoisted_39,
                        _createVNode(_component_InputText, {
                          class: _normalizeClass(["w-full", `${$setup.v$.store.order.customer.city.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.store.order.customer.city.$error,
                          modelValue: $data.store.order.customer.city,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($data.store.order.customer.city) = $event)),
                          type: "text",
                          name: "city",
                          id: "city"
                        }, null, 8, ["class", "invalid", "modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.store.order.customer.city.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ]),
                      _createElementVNode("div", _hoisted_40, [
                        _hoisted_41,
                        _createVNode(_component_InputText, {
                          class: _normalizeClass(["w-full", `${$setup.v$.store.order.customer.zip.$error ? 'bg-red-200' : ''}`]),
                          invalid: $setup.v$.store.order.customer.zip.$error,
                          modelValue: $data.store.order.customer.zip,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($data.store.order.customer.zip) = $event)),
                          type: "text",
                          name: "zip",
                          id: "zip"
                        }, null, 8, ["class", "invalid", "modelValue"]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.v$.store.order.customer.zip.$errors, (error, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "text-sm font-italic text-red-400"
                          }, _toDisplayString(error.$message), 1))
                        }), 128))
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _hoisted_44,
                        _createVNode(_component_InputText, {
                          class: "w-full",
                          modelValue: $data.store.order.customer.comment,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (($data.store.order.customer.comment) = $event)),
                          type: "text",
                          name: "comment",
                          id: "comment"
                        }, null, 8, ["modelValue"])
                      ])
                    ])
                  ]),
                  _: 1
                }),
                _createElementVNode("div", _hoisted_45, [
                  _createVNode(_component_PrimevueButton, {
                    type: "submit",
                    label: "Uložiť",
                    text: "",
                    raised: "",
                    class: "uppercase"
                  }),
                  _createVNode(_component_router_link, { to: "/mod-orders/orders" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_PrimevueButton, {
                        label: "Zrušiť",
                        severity: "danger",
                        text: "",
                        raised: "",
                        class: "uppercase"
                      })
                    ]),
                    _: 1
                  })
                ])
              ], 32)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.$route.params.orderId > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
            _createElementVNode("div", _hoisted_47, [
              _createVNode(_component_CortizoProform, {
                orderId: this.$route.params.orderId
              }, null, 8, ["orderId"])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _createVNode(_component_AttachmentsByType, {
                orderId: this.$route.params.orderId
              }, null, 8, ["orderId"])
            ])
          ]))
        : _createCommentVNode("", true),
      (this.$route.params.orderId > 0)
        ? (_openBlock(), _createBlock(_component_PrimevueCard, {
            key: 2,
            class: "w-full my-2 ml-4"
          }, {
            title: _withCtx(() => [
              _hoisted_49
            ]),
            content: _withCtx(() => [
              _createVNode(_component_Fieldset, {
                legend: "Rezervovanie kusov",
                toggleable: "",
                collapsed: true
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ReservedItems, {
                    orderId: String(this.$route.params.orderId),
                    reserved: true,
                    search: false
                  }, null, 8, ["orderId"])
                ]),
                _: 1
              }),
              _createVNode(_component_Fieldset, {
                legend: "Zoznam rezervovaných kusov",
                toggleable: "",
                collapsed: true,
                style: {"border":"5px solid rgb(0,182,147)"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ReservedItems, {
                    orderId: String(this.$route.params.orderId),
                    reserved: false,
                    search: false
                  }, null, 8, ["orderId"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (this.$route.params.orderId > 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
            ($data.store.user.department.id != 1)
              ? (_openBlock(), _createBlock(_component_PrimevueCard, {
                  key: 0,
                  class: "w-xs:w-12 md:w-6 lg:w-6 xl:w-6 m-2"
                }, {
                  title: _withCtx(() => [
                    _hoisted_51
                  ]),
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createVNode(_component_EditorMessage, {
                        orderId: String(this.$route.params.orderId),
                        orderCode: String($data.store.order.orderCode),
                        orderDesc: $data.store.order.description
                      }, null, 8, ["orderId", "orderCode", "orderDesc"])
                    ]),
                    _createVNode(_component_CommunicationList, {
                      internal: false,
                      orderId: String(this.$route.params.orderId)
                    }, null, 8, ["orderId"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_PrimevueCard, { class: "w-xs:w-12 md:w-5 lg:w-5 xl:w-5 m-2" }, {
              title: _withCtx(() => [
                _hoisted_53
              ]),
              content: _withCtx(() => [
                _createElementVNode("div", _hoisted_54, [
                  _createVNode(_component_EditorMessageInt, {
                    orderId: String(this.$route.params.orderId)
                  }, null, 8, ["orderId"])
                ]),
                _createVNode(_component_CommunicationList, {
                  internal: true,
                  orderId: String(this.$route.params.orderId)
                }, null, 8, ["orderId"])
              ]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ConfirmDialog)
  ], 64))
}